import { render, staticRenderFns } from "./BarWork.vue?vue&type=template&id=938bb57a&scoped=true"
import script from "./BarWork.vue?vue&type=script&lang=js"
export * from "./BarWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938bb57a",
  null
  
)

export default component.exports